import React from 'react';
import { useSelector } from 'react-redux';
const StateMachine = require('javascript-state-machine');

//TODO: may have to work on more statuses to account for new process between requests and requestedItems
export const statusStateMachine = new StateMachine({
  initial: 'Requested',
  transitions: [
    // { name: 'Health Dept - Auto Approved', from: 'Requested', to: 'Health Dept. - Auto Approved' },
    { name: 'Ordered', from: 'Requested', to: 'Ordered' },
    { name: 'Pull From Stock', from: 'Requested', to: 'Pull From Stock'},
    { name: 'On Hold', from: 'Requested', to: 'On Hold' },
    { name: 'Denied', from: 'Requested', to: 'Denied' },
    // { name: 'Cancelled', from: 'Requested', to: 'Cancelled' },
    
    { name: 'Requested', from: 'Ordered', to: 'Requested' },
    { name: 'Received', from: 'Ordered', to: 'Received' },
    { name: 'On Hold', from: 'Ordered', to: 'On Hold' },
    // { name: 'Cancelled', from: 'Ordered', to: 'Cancelled' },

    { name: 'Ready for EOne', from: 'Pull From Stock', to: 'Ready for EOne'},
    { name: 'Completed', from: 'Pull From Stock', to: 'Completed'},
    
    { name: 'On Hold', from: 'Received', to: 'On Hold' },
    { name: 'Barcoded', from: 'Received', to: 'Barcoded' },
    // { name: 'Cancelled', from: 'Received', to: 'Cancelled' },
    { name: 'Completed', from: 'Received', to: 'Completed' },
    
    { name: 'Requested', from: 'On Hold', to: 'Requested' },
    { name: 'Ordered', from: 'On Hold', to: 'Ordered' },
    { name: 'Received', from: 'On Hold', to: 'Received' },
    { name: 'Barcoded', from: 'On Hold', to: 'Barcoded' },
    // { name: 'Cancelled', from: 'On Hold', to: 'Cancelled' },
    
    
    { name: 'Ready for EOne', from: 'Barcoded', to: 'Ready for EOne' },
    { name: 'On Hold', from: 'Barcoded', to: 'On Hold' },
    { name: 'Manual Entry', from: 'Barcoded', to: 'Manual Entry'},

    { name: 'Manual Entry', from: 'Ready for EOne', to: 'Manual Entry'},
    { name: 'Completed', from: 'Ready for EOne', to: 'Completed' },
    
    { name: 'Ready for EOne', from: 'Import Error', to: 'Ready for EOne' },
    { name: 'Manual Entry', from: 'Import Error', to: 'Manual Entry'},
    
    { name: 'Completed', from: 'Health Dept. - Auto Approved', to: 'Completed' },
    
    { name: 'Ordered', from: 'Partially Ordered', to: 'Ordered' },

    { name: 'Transfer Received', from: 'Transfer Initiated', to: 'Transfer Received'},
    { name: 'Transfer Installed, Pending Approval', from: 'Transfer Received', to: 'Transfer Installed, Pending Approval'},
    // {name: '----------', from: '*', to: '*'},
    
    // { name: 'Partially Ordered', from: 'Requested', to: 'Partially Ordered' },
    // { name: 'Received', from: 'Requested', to: 'Received' },



    {
      name: 'goto',
      from: '*',
      to: function (s) {
        return s;
      },
    },
  ],
  methods: {
    onOnHold: () => {
      // console.log('On Hold Called');
    },
    onCompleted: () => {
      // console.log('Completed!');
    },
    onCancelled: () => {
      // console.log('Cancelled!');
    },
  },
});

export const initializeState = (state) => {
  statusStateMachine.goto(state);

  // console.log('All States: ' + statusStateMachine.allStates());
  // console.log('Current State: ' + statusStateMachine.state);
  // console.log('Allowed Transitions: ' + statusStateMachine.transitions());
  // console.log('All Transitions: ' + statusStateMachine.allTransitions());
};

export const getOptions = (status) => {
  initializeState(status);
  // console.log('Allowed Transitions: ' + statusStateMachine.transitions());
  return statusStateMachine.transitions();
};

export const getAdminOptions = (status) => {
  let options = ['--Admin--']
  options.push(...statusStateMachine.allTransitions().filter(item => !(statusStateMachine.transitions().includes(item))))
  return options
}

export const Statuses = (props) => {
  const [options, setOptions] = React.useState([]);
const [itAdmin, setItAdmin] = React.useState(false)
const { user } = useSelector((state: any) => ({
  user: state.user
}))
  let status = props.value || 'Requested';
  if (status.substr(0, 5) === 'Error') {
    status = 'Import Error';
  }
  React.useEffect(() => {
    let admin = false
    user.roles.forEach((role) => {
      if(role.isAdmin) admin = true
      if(role.roleId === 20 || role.roleId === 21) admin = true
    })
    setItAdmin(user.currentRole.departmentId === 19 && admin)
  }, [])

  React.useEffect(() => {
    setOptions(getOptions(status));
  }, [status]);

  if(!props.noParent){
    return(
      <>
      {!props.noLabel && <label className={props.lblClass}>{props.label}</label>}
      <select
        className={props.selClass}
        id={props.idName}
        name={props.idName}
        disabled={props.disabled}
        //onChange={props.formik.handleChange}
        onChange={props.formik ? props.formik.handleChange : props.onChange}
        onAuxClickCapture={() => alert('right click')}
        value={props.value}
        defaultValue={1}>
        <option value={status}>{status}</option>
        {options.map((value, index) => {
          if (value !== 'goto') {
            return <option key={value} value={value}>{value}</option>;
          }
          return '';
        })}
        {itAdmin && getAdminOptions(status).map((value, index) => {
          return <option key={value} style={{backgroundColor: '#f93'}} value={value}>{value}</option>
        })}
      </select></>
    )
  }

  return (
    <div className='form-group'>
      {!props.noLabel && <label className={props.lblClass}>{props.label}</label>}
      <select
        className={props.selClass}
        id={props.idName}
        name={props.idName}
        disabled={props.disabled}
        //onChange={props.formik.handleChange}
        onChange={props.formik ? props.formik.handleChange : props.onChange}
        onAuxClickCapture={() => alert('right click')}
        value={props.value}
        defaultValue={1}>
        <option value={status}>{status}</option>
        {options.map((value, index) => {
          if (value !== 'goto') {
            return (
              <option key={value} value={value}>
                {value}
              </option>
            );
          }
          return '';
        })}
        {itAdmin &&
          getAdminOptions(status).map((value, index) => {
            return (
              <option key={value} style={{ backgroundColor: '#f93' }} value={value}>
                {value}
              </option>
            );
          })}
      </select>
    </div>
  );
};

export default Statuses;
